// entity_type keys MUST match src/services/document-lineage.js. Routes must
// match the frontend detail-page routes in App.tsx.
export type FavEntityDef = { entity_type: string; route: string; label: string; icon?: string };

export const FAVORITE_ENTITIES: FavEntityDef[] = [
  // documents (mirror document-lineage.js)
  { entity_type: 'customer_invoice', route: '/ar-invoices',     label: 'AR Invoice' },
  { entity_type: 'vendor_invoice',   route: '/ap-invoices',     label: 'AP Invoice' },
  { entity_type: 'sales_order',      route: '/sales-orders',    label: 'Sales Order' },
  { entity_type: 'purchase_order',   route: '/purchase-orders', label: 'Purchase Order' },
  { entity_type: 'sales_quote',      route: '/quotes',          label: 'Quote' },
  { entity_type: 'journal_entry',    route: '/journal',         label: 'Journal Entry' },
  // master data (only entities with confirmed /:id detail routes in App.tsx)
  { entity_type: 'customer', route: '/customers', label: 'Customer' },
  { entity_type: 'vendor',   route: '/vendors',   label: 'Vendor' },
  { entity_type: 'item',     route: '/items',     label: 'Item' },
  { entity_type: 'project',  route: '/projects',  label: 'Project' },
  // NOTE: 'account' dropped — /accounts has no /:id detail route in App.tsx
];

// Longest route first so e.g. '/ar-invoices' wins over a hypothetical '/ar'.
const BY_ROUTE = [...FAVORITE_ENTITIES].sort((a, b) => b.route.length - a.route.length);

// Static sub-pages of an entity route, never a record id: its new form and
// its line log (/ar-invoices/lines, /sales-orders/lines…), the bill scanner
// (/ap-invoices/scan, /scan-inbox) and recurring journals, starred as pages.
const RESERVED = new Set(['new', 'create', 'lines', 'scan', 'scan-inbox', 'recurring']);

export function entityForPath(
  pathname: string,
): { entity_type: string; entity_id: string; icon?: string; typeLabel: string } | null {
  for (const d of BY_ROUTE) {
    const prefix = d.route + '/';
    if (pathname.startsWith(prefix)) {
      const rest = pathname.slice(prefix.length);
      const id = rest.split('/')[0];
      if (!id || RESERVED.has(id)) return null;
      return { entity_type: d.entity_type, entity_id: id, icon: d.icon, typeLabel: d.label };
    }
  }
  return null;
}

export function routeForEntity(entity_type: string): string | undefined {
  return FAVORITE_ENTITIES.find((d) => d.entity_type === entity_type)?.route;
}
